import { useState } from "react";
import Banner from "../component/Banner";
import DropdownMenu from "../component/DropdownMenu";
import Footer from "../component/Footer";
import Navbar from "../component/Navbar";
import PageTransition from "../component/PageTransition";
import Modal from "../component/Modal";
import { motion } from "framer-motion";

export default function Contact() {
  const [showContent, setShowContent] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const closeModal = () => setShowModal(false);
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
      },
    },
  };
  return (
    <>
      <PageTransition showContent={showContent} setShowContent={setShowContent}>
        Contact Us
      </PageTransition>
      {showContent && (
        <>
          <Navbar />
          <Banner
            img="/images/banner/412560910_6868375936592125_2554178217129048543_n 1.png"
            title="ติดต่อเรา"
          />

          <DropdownMenu />

          <div className="min-w-screen mx-auto h-full flex flex-col justify-center items-center gap-12 py-20 px-4 bg-gradient-to-b from-blue-50 to-white">
            <motion.div
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="text-center"
            >
              <h1 className="text-4xl lg:text-6xl font-bold text-[#0F4D81] mb-4">
                ติดต่อเรา
              </h1>
              <p className="text-lg lg:text-xl text-gray-600 max-w-2xl">
                สามารถติดต่อเราผ่านช่องทางใดก็ได้ด้านล่าง
              </p>
            </motion.div>

            <motion.div
              variants={containerVariants}
              initial="hidden"
              animate="visible"
              className="grid grid-cols-2 lg:grid-cols-5 gap-6 w-full max-w-screen-xl"
            >
              {/* อีเมล */}
              <motion.div
                variants={itemVariants}
                whileHover={{ scale: 1.05 }}
                onClick={() =>
                  window.open("mailto:novelcmu.office@gmail.com", "_blank")
                }
                className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer border border-blue-100 hover:border-blue-200 flex flex-col items-center justify-center text-center group "
              >
                <div className="bg-[#5badd2] w-20 h-20 lg:w-24 lg:h-24 rounded-full flex items-center justify-center mb-4 group-hover:bg-[#3a9bc8] transition-colors">
                  <i className="fa fa-envelope text-3xl lg:text-4xl text-white"></i>
                </div>
                <h3 className="font-semibold text-gray-800">อีเมล</h3>
                <p className="text-xs lg:text-sm text-gray-500 mt-1">
                  Click
                </p>
              </motion.div>

              {/* โทรศัพท์ */}
              <motion.div
                variants={itemVariants}
                whileHover={{ scale: 1.05 }}
                onClick={() => window.open("tel:0984582500")}
                className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer border border-blue-100 hover:border-blue-200 flex flex-col items-center justify-center text-center group"
              >
                <div className="bg-[#5badd2] w-20 h-20 lg:w-24 lg:h-24 rounded-full flex items-center justify-center mb-4 group-hover:bg-[#3a9bc8] transition-colors">
                  <i className="fa fa-phone text-3xl lg:text-4xl text-white"></i>
                </div>
                <h3 className="font-semibold text-gray-800">โทรศัพท์</h3>
                <p className="text-xs lg:text-sm text-gray-500 mt-1">
                  098 458 2500
                </p>
              </motion.div>

              {/* ที่ตั้ง */}
              <motion.div
                variants={itemVariants}
                whileHover={{ scale: 1.05 }}
                onClick={() =>
                  window.open(
                    "https://maps.app.goo.gl/LpiqZSDmeuqHaoue8",
                    "_blank"
                  )
                }
                className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer border border-blue-100 hover:border-blue-200 flex flex-col items-center justify-center text-center group"
              >
                <div className="bg-[#5badd2] w-20 h-20 lg:w-24 lg:h-24 rounded-full flex items-center justify-center mb-4 group-hover:bg-[#3a9bc8] transition-colors">
                  <i className="fa fa-map-marker-alt text-3xl lg:text-4xl text-white"></i>
                </div>
                <h3 className="font-semibold text-gray-800">ที่ตั้ง</h3>
                <p className="text-xs lg:text-sm text-gray-500 mt-1">
                  ดูแผนที่
                </p>
              </motion.div>

              {/* Facebook */}
              <motion.div
                variants={itemVariants}
                whileHover={{ scale: 1.05 }}
                onClick={() =>
                  window.open("https://www.facebook.com/NOVEL.VMCMU/", "_blank")
                }
                className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer border border-blue-100 hover:border-blue-200 flex flex-col items-center justify-center text-center group"
              >
                <div className="bg-[#5badd2] w-20 h-20 lg:w-24 lg:h-24 rounded-full flex items-center justify-center mb-4 group-hover:bg-[#3a9bc8] transition-colors">
                  <i className="fab fa-facebook-f text-3xl lg:text-4xl text-white"></i>
                </div>
                <h3 className="font-semibold text-gray-800">Facebook</h3>
                <p className="text-xs lg:text-sm text-gray-500 mt-1">
                  NOVEL.VMCMU
                </p>
              </motion.div>

              {/* Line */}
              <motion.div
                variants={itemVariants}
                whileHover={{ scale: 1.05 }}
                onClick={() => setShowModal(true)}
                className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer border border-blue-100 hover:border-blue-200 flex flex-col items-center justify-center text-center group"
              >
                <div className="bg-[#5badd2] w-20 h-20 lg:w-24 lg:h-24 rounded-full flex items-center justify-center mb-4 group-hover:bg-[#3a9bc8] transition-colors">
                  <i className="fab fa-line text-3xl lg:text-4xl text-white"></i>
                </div>
                <h3 className="font-semibold text-gray-800">Line</h3>
                <p className="text-xs lg:text-sm text-gray-500 mt-1">
                  ติดต่อผ่าน Line
                </p>
              </motion.div>
            </motion.div>

            {/* เบอร์โทรศัพท์เพิ่มเติม */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.8, duration: 0.6 }}
              className="mt-8 w-full max-w-4xl bg-white p-6 rounded-xl shadow-md border border-blue-50"
            >
              <h3 className="text-xl font-semibold text-[#0F4D81] mb-4 text-center">
                เบอร์โทรศัพท์แผนกต่าง ๆ
              </h3>
              <motion.div
                className="grid grid-cols-1 md:grid-cols-3 gap-4"
                variants={containerVariants}
                initial="hidden"
                animate="visible"
              >
                <motion.div
                  variants={itemVariants}
                  className="bg-blue-50 p-4 rounded-lg text-center hover:bg-blue-100 transition-colors"
                >
                  <h4 className="font-medium text-gray-800">
                    เวชระเบียน (ชั้น 1)
                  </h4>
                  <p className="text-blue-600 font-semibold mt-1">
                    053-948-031
                  </p>
                  <p className="text-blue-600 font-semibold">053-948-112</p>
                </motion.div>
                <motion.div
                  variants={itemVariants}
                  className="bg-blue-50 p-4 rounded-lg text-center hover:bg-blue-100 transition-colors"
                >
                  <h4 className="font-medium text-gray-800">
                    เวชระเบียนศัลยกรรม
                  </h4>
                  <p className="text-blue-600 font-semibold mt-1">
                    053-948-120
                  </p>
                </motion.div>
                <motion.div
                  variants={itemVariants}
                  className="bg-blue-50 p-4 rounded-lg text-center hover:bg-blue-100 transition-colors"
                >
                  <h4 className="font-medium text-gray-800">
                    เวชระเบียน (ชั้น 2)
                  </h4>
                  <p className="text-blue-600 font-semibold mt-1">
                    053-948-123
                  </p>
                </motion.div>
              </motion.div>
            </motion.div>
          </div>
          <Modal
            id="default-modal"
            title={"Line official NOVEL CMU"}
            size="max-w-sm"
            linkDownload={""}
            show={showModal}
            onClose={closeModal}
          >
            <div className="flex flex-col justify-center items-center gap-y-5">
              <img
                src="https://qr-official.line.me/gs/M_081ctdmi_BW.png?oat_content=qr"
                alt="Line ID"
              />
              <button
                onClick={() => window.open("https://lin.ee/zFKvapU", "_blank")}
                className="bg-green-500 hover:bg-green-600 w-full transition-all duration-500 ease-linear text-white py-2 px-4 rounded "
              >
                Add Line Official NOVEL CMU
              </button>
            </div>
          </Modal>
          <Footer />
        </>
      )}
    </>
  );
}
